angular.module('gym.components').directive('calendarFilters', function() {
  return {
    restrict: 'E',
    template: require('templates/components/calendar/calendar_filters.html.slim'),
    scope: {
      locations: '=',
      instructors: '=',
      eventTypes: '=',
      styles: '=',
      selectedLocations: '=',
      selectedInstructors: '=',
      selectedEventTypes: '=',
      selectedStyles: '=',
      multiSelect: '=',
      displayOldEventsHiddenWarning: '=',
      oldEventDisplayThresholdDate: '=',
      unableToManageOtherContacts: '=',
      disableShowAllInstructors: '=',
      hideInstructor: '=',
      collapseMobile: '=',
      internal: '=',
      params: '=',
      onParamsChange: '&',
      onLocationsChange: '&',
      onInstructorsChange: '&',
      onEventTypesChange: '&',
      onStylesChange: '&'
    },
    controller: ["$scope", "$filter", "$stateParams", "$modal", "MasqueradingService", function($scope, $filter, $stateParams, $modal, MasqueradingService) {
      $scope.stylesFilterAvailable = function() {
        var ref;
        return $scope.internal && ((ref = $scope.styles) != null ? ref.length : void 0) > 1;
      };
      $scope.isMasquerading = MasqueradingService.isMasquerading();
      $scope.selectedLocationLabel = function() {
        var ref;
        if (((ref = $scope.selectedLocations) != null ? ref.length : void 0) && $scope.selectedLocations.length !== $scope.locations.length) {
          if ($scope.selectedLocations.length > 1) {
            return `${$scope.selectedLocations.length} locations`;
          } else {
            return $filter('limitString')($scope.locationName($scope.selectedLocations[0]), 40);
          }
        } else {
          return "All Locations";
        }
      };
      $scope.locationName = function(location) {
        if (location.active) {
          return location.name;
        } else {
          return `[Deactivated] ${location.name}`;
        }
      };
      $scope.instructorLabel = function() {
        var instructor, name, ref;
        if (((ref = $scope.selectedInstructors) != null ? ref.length : void 0) && $scope.selectedInstructors.length !== $scope.instructors.length) {
          if ($scope.selectedInstructors.length > 1) {
            return `${$scope.selectedInstructors.length} instructors`;
          } else {
            instructor = $scope.selectedInstructors[0];
            name = instructor.name || `${instructor.first_name} ${instructor.last_name}`;
            return $filter('limitString')(name, 40);
          }
        } else {
          return "All Instructors";
        }
      };
      $scope.eventFiltersMap = {
        empty: 'Empty events',
        full: 'Full events',
        not_empty: 'Non-empty events',
        not_full: 'Non-full events',
        free: '"Free" events',
        not_free: 'Non-"free" events',
        public: 'Website-visible events',
        private: 'Website-hidden events',
        waitlist_enabled: 'Waitlist-enabled events',
        waitlist_disabled: 'Waitlist-disabled events',
        waitlist_not_empty: 'Events with non-empty waitlists',
        infinite_event_series: 'Infinite event series',
        repeating_never: 'One-off events (AO)',
        repeating_daily: 'Repeating daily (AO)',
        repeating_weekly: 'Repeating weekly (AO)',
        repeating_monthly: 'Repeating monthly (AO)',
        cancelled: 'Cancelled events only',
        ex_cancelled: 'Exclude cancelled events'
      };
      $scope.eventsLabel = function() {
        var ref;
        return $scope.eventFiltersMap[(ref = $scope.params) != null ? ref.general_filter : void 0] || "All events";
      };
      $scope.eventFilters = ['empty', 'full', 'not_empty', 'not_full', 'free', 'not_free', 'public', 'private', 'waitlist_enabled', 'waitlist_disabled', 'waitlist_not_empty', 'cancelled', 'ex_cancelled'];
      if ($scope.isMasquerading) {
        $scope.eventFilters.push('infinite_event_series');
        $scope.eventFilters.push('repeating_never');
        $scope.eventFilters.push('repeating_daily');
        $scope.eventFilters.push('repeating_weekly');
        $scope.eventFilters.push('repeating_monthly');
      }
      $scope.selectGeneralFilter = function(val) {
        if ($scope.params) {
          $scope.params.general_filter = val;
        }
        return $scope.onParamsChange();
      };
      $scope.isInstructorSelected = function(instructor) {
        return $scope.selectedInstructors && !!_.find($scope.selectedInstructors, function(item) {
          return item.id === instructor.id;
        });
      };
      $scope.isLocationSelected = function(location) {
        return $scope.selectedLocations && !!_.find($scope.selectedLocations, function(item) {
          return item.id === location.id;
        });
      };
      $scope.isFiltersAvailable = function() {
        return $scope.internal || $scope.locations.length > 1 || $scope.instructors.length > 1 || $stateParams.event_type_id || $stateParams['event_type_id[]'];
      };
      $scope.instructorName = function(instructor) {
        return instructor.first_name + ' ' + instructor.last_name;
      };
      $scope.resetLocations = function() {
        return $scope.onLocationsChange({
          locations: []
        });
      };
      $scope.resetInstructors = function() {
        return $scope.onInstructorsChange({
          instructors: []
        });
      };
      $scope.selectLocation = function(location) {
        var selectedLocations;
        selectedLocations = $scope.multiSelect ? $scope.isLocationSelected(location) ? $scope.selectedLocations.filter(function(item) {
          return item.id !== location.id;
        }) : $scope.selectedLocations.concat(location) : [location];
        if (selectedLocations.length === $scope.locations.length) {
          selectedLocations = [];
        }
        return $scope.onLocationsChange({
          locations: selectedLocations
        });
      };
      $scope.selectInstructor = function(instructor) {
        var selectedInstructors;
        selectedInstructors = $scope.multiSelect ? $scope.isInstructorSelected(instructor) ? $scope.selectedInstructors.filter(function(item) {
          return item.id !== instructor.id;
        }) : $scope.selectedInstructors.concat(instructor) : [instructor];
        if (selectedInstructors.length === $scope.instructors.length) {
          selectedInstructors = [];
        }
        return $scope.onInstructorsChange({
          instructors: selectedInstructors
        });
      };
      $scope.eventTypeName = function(eventType) {
        if (eventType.active) {
          return eventType.name;
        } else {
          return `[Deactivated] ${eventType.name}`;
        }
      };
      $scope.selectedEventTypesLabel = function() {
        var ref;
        if (((ref = $scope.selectedEventTypes) != null ? ref.length : void 0) && $scope.selectedEventTypes.length !== $scope.eventTypes.length) {
          if ($scope.selectedEventTypes.length > 1) {
            return `${$scope.selectedEventTypes.length} types`;
          } else {
            return $filter('limitString')($scope.eventTypeName($scope.selectedEventTypes[0]), 40);
          }
        } else {
          return "All Types";
        }
      };
      $scope.selectEventType = function(eventType) {
        var selectedEventTypes;
        selectedEventTypes = $scope.multiSelect ? $scope.isEventTypeSelected(eventType) ? $scope.selectedEventTypes.filter(function(item) {
          return item.id !== eventType.id;
        }) : $scope.selectedEventTypes.concat(eventType) : [eventType];
        if (selectedEventTypes.length === $scope.eventTypes.length) {
          selectedEventTypes = [];
        }
        return $scope.onEventTypesChange({
          eventTypes: selectedEventTypes
        });
      };
      $scope.resetEventTypes = function() {
        return $scope.onEventTypesChange({
          eventTypes: []
        });
      };
      $scope.selectEventType = function(eventType) {
        var selectedEventTypes;
        selectedEventTypes = $scope.multiSelect ? $scope.isEventTypeSelected(eventType) ? $scope.selectedEventTypes.filter(function(item) {
          return item.id !== eventType.id;
        }) : $scope.selectedEventTypes.concat(eventType) : [eventType];
        if (selectedEventTypes.length === $scope.eventTypes.length) {
          selectedEventTypes = [];
        }
        return $scope.onEventTypesChange({
          eventTypes: selectedEventTypes
        });
      };
      $scope.isEventTypeSelected = function(eventType) {
        return $scope.selectedEventTypes && !!_.find($scope.selectedEventTypes, function(item) {
          return item.id === eventType.id;
        });
      };
      $scope.styleName = function(style) {
        return style.name;
      };
      $scope.selectedStylesLabel = function() {
        var ref;
        if (((ref = $scope.selectedStyles) != null ? ref.length : void 0) && $scope.selectedStyles.length !== $scope.styles.length) {
          if ($scope.selectedStyles.length > 1) {
            return `${$scope.selectedStyles.length} styles`;
          } else {
            return $filter('limitString')($scope.styleName($scope.selectedStyles[0]), 40);
          }
        } else {
          return "All Styles";
        }
      };
      $scope.selectStyle = function(style) {
        var selectedStyles;
        selectedStyles = $scope.multiSelect ? $scope.isStyleSelected(style) ? $scope.selectedStyles.filter(function(item) {
          return item.id !== style.id;
        }) : $scope.selectedStyles.concat(style) : [style];
        if (selectedStyles.length === $scope.styles.length) {
          selectedStyles = [];
        }
        return $scope.onStylesChange({
          styles: selectedStyles
        });
      };
      $scope.resetStyles = function() {
        return $scope.onStylesChange({
          styles: []
        });
      };
      $scope.selectStyle = function(style) {
        var selectedStyles;
        selectedStyles = $scope.multiSelect ? $scope.isStyleSelected(style) ? $scope.selectedStyles.filter(function(item) {
          return item.id !== style.id;
        }) : $scope.selectedStyles.concat(style) : [style];
        if (selectedStyles.length === $scope.styles.length) {
          selectedStyles = [];
        }
        return $scope.onStylesChange({
          styles: selectedStyles
        });
      };
      $scope.isStyleSelected = function(style) {
        return $scope.selectedStyles && !!_.find($scope.selectedStyles, function(item) {
          return item.id === style.id;
        });
      };
      return $scope.displayModal = function() {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/components/calendar/calendar_filters_modal.html.slim'),
          controller: 'CalendarFiltersModalCtrl',
          resolve: {
            locations: function() {
              return $scope.locations;
            },
            instructors: function() {
              return $scope.instructors;
            },
            eventTypes: function() {
              return $scope.eventTypes;
            },
            styles: function() {
              if ($scope.stylesFilterAvailable()) {
                return $scope.styles;
              } else {
                return [];
              }
            },
            selectedLocations: function() {
              return [].concat($scope.selectedLocations);
            },
            selectedInstructors: function() {
              return [].concat($scope.selectedInstructors);
            },
            selectedEventTypes: function() {
              return [].concat($scope.selectedEventTypes);
            },
            selectedStyles: function() {
              return [].concat($scope.selectedStyles);
            },
            unableToManageOtherContacts: function() {
              return $scope.unableToManageOtherContacts;
            },
            disableShowAllInstructors: function() {
              return $scope.disableShowAllInstructors;
            },
            hideInstructor: function() {
              return $scope.hideInstructor;
            },
            multiSelect: function() {
              return $scope.multiSelect;
            },
            eventFilters: function() {
              return $scope.eventFilters;
            },
            eventFiltersMap: function() {
              return $scope.eventFiltersMap;
            },
            params: function() {
              return angular.extend({}, $scope.params);
            }
          }
        });
        return modalInstance.result.then(function(result) {
          $scope.selectGeneralFilter(result.general_filter);
          if (result.locations) {
            $scope.onLocationsChange({
              locations: result.locations
            });
          }
          if (result.instructors) {
            $scope.onInstructorsChange({
              instructors: result.instructors
            });
          }
          if (result.eventTypes) {
            $scope.onEventTypesChange({
              eventTypes: result.eventTypes
            });
          }
          if (result.styles) {
            return $scope.onStylesChange({
              styles: result.styles
            });
          }
        });
      };
    }]
  };
});
